export default __webpack_public_path__ + "static/media/65l_bag.e01b7165.jpg";